
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.0","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.56 7.74L3.8 3.99a.362.362 0 00-.51-.01l-.01.01-.59.59c-.14.14-.14.38 0 .52l2.22 2.11H.14c-.15 0-.27.12-.27.27v1c.01.15.12.26.27.26h4.77L2.7 10.88c-.14.14-.14.38 0 .52l.59.59c.14.14.38.14.52 0l3.75-3.74c.14-.14.14-.37 0-.51zm.89 0l3.73-3.75c.13-.14.35-.15.49-.02.01 0 .01.01.02.02l.6.59c.14.14.14.38 0 .52L11.1 7.21h4.63c.15 0 .27.12.27.27v1c-.01.15-.12.26-.27.26H11.1l2.21 2.14c.14.14.14.38 0 .52l-.6.59c-.14.14-.37.14-.51 0L8.45 8.25a.345.345 0 010-.51c-.01 0-.01 0 0 0z"}})])
          )
        }
      }
    